<template lang="pug">
select.card-select(v-model="value")
  template(v-for="c in options")
    option(:value="c.id"
    ) {{ c.brand.toUpperCase() }} | {{ c.card_number }} | {{ z(c.month) }}/{{ c.year }}
</template>

<script>
export default {
  name: 'CardSelect',
  props: {
    value: {
      type: Number,
      default: 0,
      required: false,
    },
    options: {
      type: Array,
      default: () => ([]),
      required: false,
    },
  },
  data: () => ({}),
  methods: {
    z(d) {
      return parseInt(d, 10) < 10 ? `0${d}` : d;
    },
  },
};
</script>

<style lang="scss">
.card-select {
  max-width: 320px;
  transition: all 0.3s;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #f0efec;
  box-shadow: none;
  box-sizing: border-box;
  color: #393939;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  height: 44px;
  min-height: 44px;
  outline: none;
  padding: 0 24px;
  width: 100%;
  flex: 1;
  &::placeholder {
    color: #7b7b7b;
  }
  &:focus {
    border-color: #8200ff;
  }
}
</style>
